import React, { useState, useEffect } from "react";
import axios from "axios";
import { getToken } from "../../utils/tokenUtils"; // Adjust the import path as necessary
import { sub } from "date-fns";

const ResignationForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, // Added errors prop to display validation messages
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({}); // Validation errors
    const token = getToken();
    const [users, setUsers] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

    // fetching user on mount
    useEffect(() => {
        const fetchUsers = async () => {
            try {
            const res = await axios.get(`https://hrmsnew.prepstripe.com/api/users-with-employee-ids`, {
                headers: {
                    contentType: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }); // update with actual endpoint
            setUsers(res.data);
            } catch (error) {
            console.error("Failed to fetch users:", error);
            }
        };

        fetchUsers();
    }, [token]);

  const validate = () => {
    const validationErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const onlyTextRegex = /^[A-Za-z\s-]+$/;

    return validationErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      return;
    }	

    setFormErrors("")

    const submissionData = new FormData(); // Use FormData for file upload
    submissionData.append("employee_id", formData.employee_id);
    submissionData.append("resignation_date", formData.resignation_date);
    submissionData.append("last_working_day", formData.last_working_day);
    submissionData.append("notice_period_days", formData.notice_period_days);
    submissionData.append("reason", formData.reason);

    onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">

      {/* employee_id Field */}
      <div>
        <label htmlFor="employee_id" className="block dark:text-white text-sm font-medium text-gray-700">
          Employee ID <span className="text-red-500 ml-1">*</span>
        </label>
        <select
          id="employee_id"
          name="employee_id"
          value={formData.employee_id}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.employee_id ? "border-red-500" : "border-gray-300"
          }`}
          required
        >
          <option value="" disabled>
            Select Employee
          </option>
          {users.map((user) => (
            <option key={user.id} value={user.employee_id}>
              {user.employee_id} - {user.name}
            </option>
          ))}
        </select>
        {formErrors.employee_id && <p className="text-red-500 text-sm mt-1">{formErrors.employee_id}</p>}
      </div>

      {/* resignation_date Field */}
      <div>
        <label htmlFor="resignation_date" className="block dark:text-white text-sm font-medium text-gray-700">
          Resignation Date <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="date"
          id="resignation_date"
          name="resignation_date"
          value={formData.resignation_date}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.resignation_date ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.resignation_date && <p className="text-red-500 text-sm mt-1">{formErrors.resignation_date}</p>}
      </div>


      {/* resignation_date Field */}
      <div>
        <label htmlFor="last_working_day" className="block dark:text-white text-sm font-medium text-gray-700">
          Last Working Day <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="date"
          id="last_working_day"
          name="last_working_day"
          value={formData.last_working_day}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.last_working_day ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.last_working_day && <p className="text-red-500 text-sm mt-1">{formErrors.last_working_day}</p>}
      </div>

      <div>
        <label htmlFor="notice_period_days" className="block dark:text-white text-sm font-medium text-gray-700">
          Notice Period Days <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="number"
          id="notice_period_days"
          name="notice_period_days"
          value={formData.notice_period_days}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.notice_period_days ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.notice_period_days && <p className="text-red-500 text-sm mt-1">{formErrors.notice_period_days}</p>}
      </div>


      <div>
        <label htmlFor="reason" className="block dark:text-white text-sm font-medium text-gray-700">
          Reason <span className="text-red-500 ml-1">*</span>
        </label>
        <textarea
          type="number"
          id="reason"
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.reason ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        
        {formErrors.reason && <p className="text-red-500 text-sm mt-1">{formErrors.reason}</p>}
      </div>


      {/* Form Actions */}
      <div className="flex justify-between items-center space-x-4">
        <button
          type="button"
          onClick={closeModal}
          className="px-4 py-2 dark:bg-gray-900 dark:text-white bg-gray-500 text-white rounded-md hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default ResignationForm;
